<template>
	<footer
		class="footer"
		data-cy="footer"
	>
		<a href="mailto:info@centiva.ca" class="hide-mobile">
			info@centiva.ca
		</a>
		<div class="footer__round hide-mobile" />
		<a href="tel:5143756022">
			514 375-6022
		</a>
		<div class="footer__round" />
		<a target="_blank" :href="translation['privacy-policy-link']">
			{{ translation["privacy-policy"] }}
		</a>
	</footer>
</template>

<script>
import { translationMixin } from '@/mixins';

export default {
	name: 'Footer',
	mixins: [translationMixin],
	computed: {
		translation() {
			return this.currentTranslation.footer;
		}
    }
};
</script>

<style scoped lang="scss" src="./footer.scss" />
